import type { LocalizationBannerData } from "../types";

export const DEFAULT_LOCALIZATION_BANNER_DATA: LocalizationBannerData = {
  title: {
    copy: "Where do you live? Enter your address for the best offers",
  },
  label: {
    copy: "Street address and apartment",
  },
};
